export default function _searchGlobal() {
    // console.log('geoform');
    // Check if the module exists before doing anything
    const searchGlobalComponentExists =
        !!document.querySelector('.search-global');

    // If the module exists, do whatever we need to
    if (searchGlobalComponentExists) {
        // Your code here
        console.log('search global custom JS');
    }
}
_searchGlobal();
